import React from "react";

const CustomImage = ({ color }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="80px"
      height="80px"
      viewBox="0 0 1440 1440"
      enableBackground="new 0 0 1440 1440"
    >
      <path
        opacity="0.000000"
        stroke="none"
        d="
M839.000000,1441.000000 
	C559.333374,1441.000000 280.166779,1441.000000 1.000112,1441.000000 
	C1.000075,961.000122 1.000075,481.000275 1.000037,1.000306 
	C480.999786,1.000204 960.999573,1.000204 1440.999512,1.000102 
	C1440.999756,480.999664 1440.999756,960.999329 1440.999878,1440.999512 
	C1240.500000,1441.000000 1040.000000,1441.000000 839.000000,1441.000000 
M25.097885,862.265930 
	C25.781607,866.280457 26.121166,870.390564 27.205954,874.293640 
	C33.389278,896.541199 39.254944,918.894836 46.169243,940.917114 
	C56.051411,972.392212 68.358490,1002.987488 83.279396,1032.421021 
	C91.924774,1049.475342 101.729767,1065.939575 110.925156,1082.717529 
	C126.692848,1111.487427 145.962234,1137.937744 166.347153,1163.448853 
	C182.084274,1183.143311 199.455002,1201.577393 216.724319,1219.985596 
	C226.676651,1230.594238 237.827011,1240.085083 248.522095,1249.988525 
	C255.185089,1256.158203 261.590454,1262.712402 268.831848,1268.131348 
	C290.685608,1284.485352 312.504395,1300.940063 335.088257,1316.246826 
	C351.820343,1327.587158 369.357208,1337.889038 387.209930,1347.385620 
	C405.818726,1357.284546 424.901855,1366.472290 444.378113,1374.517090 
	C473.552948,1386.567871 502.820740,1398.531860 533.830322,1405.482300 
	C555.265808,1410.286621 576.606445,1415.552979 597.871033,1421.069580 
	C617.614746,1426.191772 637.970093,1425.312500 657.957642,1427.948486 
	C665.615479,1428.958374 673.356079,1429.325195 681.048157,1430.093384 
	C693.623169,1431.349121 706.166321,1433.354492 718.766357,1433.791870 
	C728.931946,1434.144775 739.168518,1432.739746 749.360291,1431.943481 
	C755.906982,1431.431885 762.427612,1430.591675 768.963135,1429.930664 
	C782.030945,1428.608765 795.095581,1427.252441 808.172546,1426.027222 
	C813.591309,1425.519409 819.142700,1425.865845 824.453186,1424.865356 
	C841.268616,1421.697144 858.064514,1418.363159 874.742249,1414.544556 
	C889.330139,1411.204590 903.872864,1407.539551 918.205811,1403.250488 
	C932.382507,1399.008179 946.424011,1394.203979 960.250061,1388.926514 
	C979.431641,1381.605103 998.636902,1374.227417 1017.310669,1365.728394 
	C1035.009766,1357.673096 1052.116333,1348.291504 1069.323730,1339.191162 
	C1077.151001,1335.051636 1084.906372,1330.053833 1093.851929,1330.211548 
	C1107.992310,1330.460571 1122.256958,1331.148438 1136.195190,1333.369019 
	C1151.421631,1335.794800 1166.351318,1340.114868 1181.382324,1343.726074 
	C1191.033936,1346.044922 1200.576172,1348.847534 1210.274292,1350.937378 
	C1221.273071,1353.307495 1232.437622,1354.906494 1243.442261,1357.252563 
	C1251.637573,1358.999756 1258.024292,1356.159546 1258.747681,1348.148804 
	C1259.501709,1339.798584 1259.811401,1330.841187 1257.611450,1322.898193 
	C1251.197021,1299.737183 1251.773560,1276.016846 1249.950928,1252.469849 
	C1249.178711,1242.492798 1248.178345,1232.511597 1246.715088,1222.616089 
	C1245.146606,1212.009277 1246.093628,1201.909912 1252.123901,1192.961670 
	C1256.326416,1186.725708 1261.633667,1181.246582 1266.210815,1175.248779 
	C1279.609253,1157.691284 1293.627808,1140.546753 1306.052368,1122.319458 
	C1327.601562,1090.705444 1347.670654,1058.125854 1362.993042,1022.903625 
	C1370.669922,1005.256714 1378.196899,987.542603 1385.600098,969.778992 
	C1396.713379,943.113342 1404.133911,915.244080 1411.638916,887.442566 
	C1414.606689,876.448914 1414.790649,864.630310 1418.347412,853.884094 
	C1426.072754,830.543457 1425.171509,806.266296 1427.972168,782.398499 
	C1428.853516,774.887695 1429.330078,767.330200 1430.121094,759.807739 
	C1431.356323,748.063599 1432.993042,736.352844 1433.871948,724.583984 
	C1434.285889,719.038879 1433.438354,713.383179 1432.979248,707.792603 
	C1432.036865,696.319092 1430.993408,684.853638 1429.950439,673.388550 
	C1428.655396,659.151428 1427.329834,644.916992 1425.993652,630.683655 
	C1425.533203,625.776672 1425.361206,620.806824 1424.428101,615.987488 
	C1422.509644,606.079529 1420.223145,596.240906 1417.985352,586.397034 
	C1414.664795,571.789673 1411.293457,557.193604 1407.869507,542.610107 
	C1405.600952,532.947754 1404.091064,522.989807 1400.693848,513.732239 
	C1390.928223,487.121674 1381.184204,460.448303 1369.886719,434.471466 
	C1360.185669,412.164612 1349.390259,390.183838 1337.196167,369.150269 
	C1323.131348,344.889801 1308.722046,320.705078 1291.005981,298.740875 
	C1281.655151,287.147797 1273.381836,274.654236 1263.652466,263.405731 
	C1250.774170,248.516373 1237.210815,234.189484 1223.439087,220.112778 
	C1213.371582,209.822388 1202.540527,200.274002 1191.958374,190.493942 
	C1185.778564,184.782532 1179.795166,178.760498 1173.070923,173.754578 
	C1151.308350,157.553452 1129.663452,141.133972 1107.162354,126.004639 
	C1089.438354,114.087402 1070.940063,103.145119 1052.027588,93.213249 
	C1022.817688,77.873695 992.890686,63.933453 961.577332,53.232071 
	C948.173767,48.651405 934.940186,43.543983 921.427795,39.320805 
	C910.876404,36.023090 900.066895,33.487350 889.275330,31.039564 
	C877.357605,28.336330 865.002441,27.149803 853.418640,23.472870 
	C830.365417,16.155327 806.449280,16.743732 782.897400,14.023070 
	C775.549011,13.174192 768.161072,12.672654 760.804810,11.885488 
	C749.227783,10.646672 737.684875,8.574334 726.085205,8.213140 
	C715.415344,7.880895 704.682434,9.244901 693.991150,10.046485 
	C687.277405,10.549848 680.587769,11.380286 673.889893,12.088600 
	C661.652344,13.382752 649.427612,14.811999 637.175903,15.952915 
	C630.599915,16.565290 623.848267,15.988303 617.403748,17.180059 
	C600.425049,20.319855 583.525635,23.933638 566.684814,27.755827 
	C557.014221,29.950665 547.550903,33.043404 537.935120,35.499954 
	C529.888611,37.555592 521.472839,38.489418 513.714600,41.288963 
	C490.116516,49.804291 466.428772,58.217632 443.398773,68.119339 
	C420.743866,77.859787 398.220306,88.258675 376.786316,100.394722 
	C351.248230,114.854523 326.093048,130.126541 302.612152,147.980576 
	C280.351105,164.907089 258.240845,181.969559 238.115799,201.434616 
	C228.483765,210.750748 218.942764,220.177200 209.711334,229.887207 
	C198.205078,241.989975 186.444946,253.934998 175.912308,266.859131 
	C161.968689,283.968750 148.368835,301.456970 135.944977,319.684753 
	C114.396751,351.299377 94.326874,383.878204 79.005722,419.101166 
	C71.329597,436.748444 63.798485,454.460815 56.397865,472.225433 
	C45.288712,498.892120 37.867657,526.761108 30.355833,554.560730 
	C27.342562,565.712219 26.668125,577.509216 23.485947,588.598206 
	C19.624794,602.053223 17.460657,615.690552 16.044403,629.503235 
	C14.217445,647.321533 12.194636,665.140869 11.149489,683.012024 
	C10.152684,700.056519 6.157134,716.933167 8.865865,734.233704 
	C10.591658,745.256226 11.026903,756.480713 12.044599,767.614258 
	C13.361114,782.016846 14.530593,796.435059 16.054201,810.815735 
	C17.035847,820.080994 18.281498,829.336243 19.889311,838.511719 
	C21.237114,846.203552 23.280842,853.773376 25.097885,862.265930 
z"/>
<path fill={color} opacity="1.000000" stroke="none" 
	d="
M25.057165,861.831543 
	C23.280842,853.773376 21.237114,846.203552 19.889311,838.511719 
	C18.281498,829.336243 17.035847,820.080994 16.054201,810.815735 
	C14.530593,796.435059 13.361114,782.016846 12.044599,767.614258 
	C11.026903,756.480713 10.591658,745.256226 8.865865,734.233704 
	C6.157134,716.933167 10.152684,700.056519 11.149489,683.012024 
	C12.194636,665.140869 14.217445,647.321533 16.044403,629.503235 
	C17.460657,615.690552 19.624794,602.053223 23.485947,588.598206 
	C26.668125,577.509216 27.342562,565.712219 30.355833,554.560730 
	C37.867657,526.761108 45.288712,498.892120 56.397865,472.225433 
	C63.798485,454.460815 71.329597,436.748444 79.005722,419.101166 
	C94.326874,383.878204 114.396751,351.299377 135.944977,319.684753 
	C148.368835,301.456970 161.968689,283.968750 175.912308,266.859131 
	C186.444946,253.934998 198.205078,241.989975 209.711334,229.887207 
	C218.942764,220.177200 228.483765,210.750748 238.115799,201.434616 
	C258.240845,181.969559 280.351105,164.907089 302.612152,147.980576 
	C326.093048,130.126541 351.248230,114.854523 376.786316,100.394722 
	C398.220306,88.258675 420.743866,77.859787 443.398773,68.119339 
	C466.428772,58.217632 490.116516,49.804291 513.714600,41.288963 
	C521.472839,38.489418 529.888611,37.555592 537.935120,35.499954 
	C547.550903,33.043404 557.014221,29.950665 566.684814,27.755827 
	C583.525635,23.933638 600.425049,20.319855 617.403748,17.180059 
	C623.848267,15.988303 630.599915,16.565290 637.175903,15.952915 
	C649.427612,14.811999 661.652344,13.382752 673.889893,12.088600 
	C680.587769,11.380286 687.277405,10.549848 693.991150,10.046485 
	C704.682434,9.244901 715.415344,7.880895 726.085205,8.213140 
	C737.684875,8.574334 749.227783,10.646672 760.804810,11.885488 
	C768.161072,12.672654 775.549011,13.174192 782.897400,14.023070 
	C806.449280,16.743732 830.365417,16.155327 853.418640,23.472870 
	C865.002441,27.149803 877.357605,28.336330 889.275330,31.039564 
	C900.066895,33.487350 910.876404,36.023090 921.427795,39.320805 
	C934.940186,43.543983 948.173767,48.651405 961.577332,53.232071 
	C992.890686,63.933453 1022.817688,77.873695 1052.027588,93.213249 
	C1070.940063,103.145119 1089.438354,114.087402 1107.162354,126.004639 
	C1129.663452,141.133972 1151.308350,157.553452 1173.070923,173.754578 
	C1179.795166,178.760498 1185.778564,184.782532 1191.958374,190.493942 
	C1202.540527,200.274002 1213.371582,209.822388 1223.439087,220.112778 
	C1237.210815,234.189484 1250.774170,248.516373 1263.652466,263.405731 
	C1273.381836,274.654236 1281.655151,287.147797 1291.005981,298.740875 
	C1308.722046,320.705078 1323.131348,344.889801 1337.196167,369.150269 
	C1349.390259,390.183838 1360.185669,412.164612 1369.886719,434.471466 
	C1381.184204,460.448303 1390.928223,487.121674 1400.693848,513.732239 
	C1404.091064,522.989807 1405.600952,532.947754 1407.869507,542.610107 
	C1411.293457,557.193604 1414.664795,571.789673 1417.985352,586.397034 
	C1420.223145,596.240906 1422.509644,606.079529 1424.428101,615.987488 
	C1425.361206,620.806824 1425.533203,625.776672 1425.993652,630.683655 
	C1427.329834,644.916992 1428.655396,659.151428 1429.950439,673.388550 
	C1430.993408,684.853638 1432.036865,696.319092 1432.979248,707.792603 
	C1433.438354,713.383179 1434.285889,719.038879 1433.871948,724.583984 
	C1432.993042,736.352844 1431.356323,748.063599 1430.121094,759.807739 
	C1429.330078,767.330200 1428.853516,774.887695 1427.972168,782.398499 
	C1425.171509,806.266296 1426.072754,830.543457 1418.347412,853.884094 
	C1414.790649,864.630310 1414.606689,876.448914 1411.638916,887.442566 
	C1404.133911,915.244080 1396.713379,943.113342 1385.600098,969.778992 
	C1378.196899,987.542603 1370.669922,1005.256714 1362.993042,1022.903625 
	C1347.670654,1058.125854 1327.601562,1090.705444 1306.052368,1122.319458 
	C1293.627808,1140.546753 1279.609253,1157.691284 1266.210815,1175.248779 
	C1261.633667,1181.246582 1256.326416,1186.725708 1252.123901,1192.961670 
	C1246.093628,1201.909912 1245.146606,1212.009277 1246.715088,1222.616089 
	C1248.178345,1232.511597 1249.178711,1242.492798 1249.950928,1252.469849 
	C1251.773560,1276.016846 1251.197021,1299.737183 1257.611450,1322.898193 
	C1259.811401,1330.841187 1259.501709,1339.798584 1258.747681,1348.148804 
	C1258.024292,1356.159546 1251.637573,1358.999756 1243.442261,1357.252563 
	C1232.437622,1354.906494 1221.273071,1353.307495 1210.274292,1350.937378 
	C1200.576172,1348.847534 1191.033936,1346.044922 1181.382324,1343.726074 
	C1166.351318,1340.114868 1151.421631,1335.794800 1136.195190,1333.369019 
	C1122.256958,1331.148438 1107.992310,1330.460571 1093.851929,1330.211548 
	C1084.906372,1330.053833 1077.151001,1335.051636 1069.323730,1339.191162 
	C1052.116333,1348.291504 1035.009766,1357.673096 1017.310669,1365.728394 
	C998.636902,1374.227417 979.431641,1381.605103 960.250061,1388.926514 
	C946.424011,1394.203979 932.382507,1399.008179 918.205811,1403.250488 
	C903.872864,1407.539551 889.330139,1411.204590 874.742249,1414.544556 
	C858.064514,1418.363159 841.268616,1421.697144 824.453186,1424.865356 
	C819.142700,1425.865845 813.591309,1425.519409 808.172546,1426.027222 
	C795.095581,1427.252441 782.030945,1428.608765 768.963135,1429.930664 
	C762.427612,1430.591675 755.906982,1431.431885 749.360291,1431.943481 
	C739.168518,1432.739746 728.931946,1434.144775 718.766357,1433.791870 
	C706.166321,1433.354492 693.623169,1431.349121 681.048157,1430.093384 
	C673.356079,1429.325195 665.615479,1428.958374 657.957642,1427.948486 
	C637.970093,1425.312500 617.614746,1426.191772 597.871033,1421.069580 
	C576.606445,1415.552979 555.265808,1410.286621 533.830322,1405.482300 
	C502.820740,1398.531860 473.552948,1386.567871 444.378113,1374.517090 
	C424.901855,1366.472290 405.818726,1357.284546 387.209930,1347.385620 
	C369.357208,1337.889038 351.820343,1327.587158 335.088257,1316.246826 
	C312.504395,1300.940063 290.685608,1284.485352 268.831848,1268.131348 
	C261.590454,1262.712402 255.185089,1256.158203 248.522095,1249.988525 
	C237.827011,1240.085083 226.676651,1230.594238 216.724319,1219.985596 
	C199.455002,1201.577393 182.084274,1183.143311 166.347153,1163.448853 
	C145.962234,1137.937744 126.692848,1111.487427 110.925156,1082.717529 
	C101.729767,1065.939575 91.924774,1049.475342 83.279396,1032.421021 
	C68.358490,1002.987488 56.051411,972.392212 46.169243,940.917114 
	C39.254944,918.894836 33.389278,896.541199 27.205954,874.293640 
	C26.121166,870.390564 25.781607,866.280457 25.057165,861.831543 
M812.000000,553.500000 
	C761.919495,503.419769 711.911865,453.266296 661.687012,403.331238 
	C653.295532,394.988190 644.572998,386.224884 632.762817,383.190643 
	C623.002441,380.682953 612.722473,379.640717 602.617004,379.185150 
	C591.876038,378.700897 580.992554,379.011353 570.320190,380.253357 
	C563.830078,381.008636 556.670715,382.853363 551.492126,386.557587 
	C541.867310,393.442230 533.427551,401.996094 524.579590,409.949799 
	C518.972107,414.990509 513.026062,419.495819 505.221619,419.967010 
	C495.297485,420.566223 485.325653,420.411133 475.409027,421.088348 
	C468.081268,421.588806 460.472809,421.852264 453.580200,424.063110 
	C438.189697,428.999786 426.333984,439.258423 416.827484,452.153809 
	C407.498108,464.808960 402.099731,478.798981 402.947174,494.858032 
	C403.271667,501.006683 403.147461,507.191101 402.968597,513.351685 
	C402.617096,525.458801 399.316681,536.251648 389.886841,544.776611 
	C384.113434,549.995911 378.826111,555.827881 373.822449,561.804932 
	C367.447510,569.419983 361.896759,577.858093 361.150085,588.003052 
	C360.200836,600.899719 360.150360,613.875122 360.087555,626.818481 
	C360.061371,632.218811 360.516663,637.722839 361.595886,643.007568 
	C364.477905,657.120117 373.718323,667.634644 382.717346,678.108826 
	C390.505676,687.173828 391.045197,692.057678 384.027679,701.569763 
	C382.656281,703.428711 381.104797,705.158936 379.584442,706.903198 
	C371.539154,716.133850 363.993317,725.765625 361.558594,738.098267 
	C360.352570,744.207275 360.081573,750.579468 360.088440,756.831787 
	C360.100159,767.443420 360.325775,778.080872 361.144104,788.654602 
	C361.552094,793.926086 362.824402,799.347473 364.838745,804.234009 
	C369.436462,815.387573 377.215210,824.561340 385.599976,832.977173 
	C447.701385,895.308472 509.889893,957.553711 572.255737,1019.620239 
	C584.946960,1032.250488 598.548889,1043.962769 611.653320,1056.181519 
	C632.576233,1075.690674 657.407471,1089.320190 682.191162,1102.964844 
	C701.218140,1113.440063 721.590149,1120.731934 742.342468,1126.978394 
	C747.985779,1128.677002 753.563965,1131.343994 759.311890,1131.798462 
	C774.979736,1133.037231 790.718628,1133.746704 806.436279,1133.888550 
	C823.708923,1134.044434 840.988220,1133.212769 858.266846,1133.043945 
	C869.034729,1132.938843 879.418335,1131.411621 889.747192,1128.088501 
	C916.267822,1119.555786 941.790649,1109.071777 964.898376,1093.218262 
	C985.478333,1079.098999 1003.631470,1062.405273 1020.669861,1044.146729 
	C1040.718262,1022.662659 1058.388428,999.606750 1073.045532,974.200317 
	C1091.785522,941.716492 1102.904297,907.139954 1102.038208,869.196472 
	C1101.499512,845.599121 1101.495605,821.989014 1100.894775,798.393799 
	C1100.728638,791.874146 1099.368408,785.374329 1098.407593,778.887512 
	C1095.983765,762.524170 1093.303101,746.196777 1091.073730,729.807617 
	C1089.964600,721.653931 1089.863770,713.366821 1088.877319,705.191956 
	C1087.088867,690.371582 1084.078857,675.639709 1083.256470,660.778076 
	C1082.433105,645.898071 1083.651733,630.904236 1083.993042,615.960754 
	C1084.335815,600.957825 1089.428955,587.120911 1094.278076,573.179504 
	C1097.211182,564.746887 1100.740723,556.213135 1101.695557,547.472717 
	C1103.169067,533.986267 1102.845947,520.284607 1102.912231,506.672455 
	C1102.939331,501.105804 1102.419189,495.456055 1101.409180,489.980377 
	C1098.796021,475.813477 1090.080688,465.624878 1078.608398,457.755890 
	C1067.798584,450.341278 1056.048706,445.628845 1042.566772,444.708466 
	C1028.624634,443.756653 1014.994385,443.683960 1001.500183,447.771942 
	C986.137695,452.425873 972.704346,460.283966 960.579102,470.772125 
	C946.076660,483.316559 932.612183,496.899811 922.200195,512.939453 
	C905.875549,538.087463 893.960938,565.451965 884.550232,593.905273 
	C883.577271,596.846924 882.523438,599.813477 881.068848,602.534119 
	C877.323181,609.540100 872.072632,610.715271 865.644592,606.071655 
	C863.235535,604.331360 860.938599,602.382385 858.831299,600.286438 
	C843.353210,584.892151 827.936218,569.436401 812.000000,553.500000 
M405.998077,1048.506958 
	C406.712097,1049.206055 407.369690,1049.976196 408.148468,1050.593628 
	C423.104340,1062.451294 439.620148,1071.768677 457.362000,1078.514038 
	C472.897400,1084.420532 488.233337,1090.816040 505.758911,1090.309204 
	C523.943420,1089.783569 534.876770,1076.931274 534.809570,1059.788940 
	C534.754639,1045.776001 528.218384,1035.368530 514.701050,1029.886597 
	C502.713318,1025.024780 490.593292,1020.380127 478.988068,1014.706177 
	C451.476044,1001.255066 430.233185,980.044556 411.505432,956.529175 
	C397.976288,939.541260 388.795898,919.837585 381.881653,899.118774 
	C375.371735,879.611511 363.055725,874.260010 344.582367,876.184326 
	C337.490173,876.923096 331.279785,880.356750 326.582245,886.353516 
	C318.133392,897.139160 318.986755,909.818787 321.592865,921.338318 
	C327.117523,945.758118 337.356049,968.633118 351.203888,989.567261 
	C357.643768,999.302734 365.076965,1008.544067 373.094055,1017.032715 
	C383.338470,1027.879761 394.627625,1037.739868 405.998077,1048.506958 
M815.736023,488.733154 
	C821.214661,497.339050 828.735535,503.043823 838.958496,504.643158 
	C853.772644,506.960724 869.325806,500.325165 873.014954,484.215698 
	C876.127136,470.625916 873.385620,457.645172 867.613464,444.967560 
	C859.060608,426.182495 846.288330,410.404633 832.085693,396.000732 
	C818.900208,382.628448 804.799133,369.884796 789.728210,358.717102 
	C772.044495,345.613281 752.338379,336.644165 729.044556,340.904938 
	C722.125732,342.170502 713.434326,348.440613 712.173340,355.586823 
	C711.062195,361.884064 711.147339,368.422852 711.045654,374.860382 
	C710.902466,383.929504 714.924866,390.922333 722.338135,396.075958 
	C735.667358,405.342285 750.633972,412.006836 762.548645,423.618286 
	C774.669250,435.430511 787.213196,446.781372 797.088196,460.603210 
	C803.483398,469.554352 809.270508,478.939911 815.736023,488.733154 
M810.080688,285.594757 
	C801.958618,295.049255 803.112427,306.156311 804.940613,317.119476 
	C806.511353,326.538849 813.522461,332.618591 820.654663,337.804352 
	C840.499023,352.232880 857.740173,369.267090 873.608215,387.874084 
	C877.093445,391.960938 881.459167,395.593414 886.062378,398.368591 
	C895.567688,404.099060 906.115784,402.348022 916.423340,401.128204 
	C921.729248,400.500275 925.724365,397.512817 929.369751,393.675262 
	C938.648193,383.907806 938.157776,363.173370 931.099792,352.823914 
	C924.615662,343.315857 917.543091,334.096741 909.815430,325.579926 
	C901.675476,316.608643 892.726257,308.310425 883.639771,300.272980 
	C868.778625,287.127533 852.668152,277.016754 831.341125,278.785919 
	C823.733643,279.416992 816.610840,279.941864 810.080688,285.594757 
z"/>
<path fill="#FEFEFE" opacity="1.000000" stroke="none" 
	d="
M812.250000,553.750000 
	C827.936218,569.436401 843.353210,584.892151 858.831299,600.286438 
	C860.938599,602.382385 863.235535,604.331360 865.644592,606.071655 
	C872.072632,610.715271 877.323181,609.540100 881.068848,602.534119 
	C882.523438,599.813477 883.577271,596.846924 884.550232,593.905273 
	C893.960938,565.451965 905.875549,538.087463 922.200195,512.939453 
	C932.612183,496.899811 946.076660,483.316559 960.579102,470.772125 
	C972.704346,460.283966 986.137695,452.425873 1001.500183,447.771942 
	C1014.994385,443.683960 1028.624634,443.756653 1042.566772,444.708466 
	C1056.048706,445.628845 1067.798584,450.341278 1078.608398,457.755890 
	C1090.080688,465.624878 1098.796021,475.813477 1101.409180,489.980377 
	C1102.419189,495.456055 1102.939331,501.105804 1102.912231,506.672455 
	C1102.845947,520.284607 1103.169067,533.986267 1101.695557,547.472717 
	C1100.740723,556.213135 1097.211182,564.746887 1094.278076,573.179504 
	C1089.428955,587.120911 1084.335815,600.957825 1083.993042,615.960754 
	C1083.651733,630.904236 1082.433105,645.898071 1083.256470,660.778076 
	C1084.078857,675.639709 1087.088867,690.371582 1088.877319,705.191956 
	C1089.863770,713.366821 1089.964600,721.653931 1091.073730,729.807617 
	C1093.303101,746.196777 1095.983765,762.524170 1098.407593,778.887512 
	C1099.368408,785.374329 1100.728638,791.874146 1100.894775,798.393799 
	C1101.495605,821.989014 1101.499512,845.599121 1102.038208,869.196472 
	C1102.904297,907.139954 1091.785522,941.716492 1073.045532,974.200317 
	C1058.388428,999.606750 1040.718262,1022.662659 1020.669861,1044.146729 
	C1003.631470,1062.405273 985.478333,1079.098999 964.898376,1093.218262 
	C941.790649,1109.071777 916.267822,1119.555786 889.747192,1128.088501 
	C879.418335,1131.411621 869.034729,1132.938843 858.266846,1133.043945 
	C840.988220,1133.212769 823.708923,1134.044434 806.436279,1133.888550 
	C790.718628,1133.746704 774.979736,1133.037231 759.311890,1131.798462 
	C753.563965,1131.343994 747.985779,1128.677002 742.342468,1126.978394 
	C721.590149,1120.731934 701.218140,1113.440063 682.191162,1102.964844 
	C657.407471,1089.320190 632.576233,1075.690674 611.653320,1056.181519 
	C598.548889,1043.962769 584.946960,1032.250488 572.255737,1019.620239 
	C509.889893,957.553711 447.701385,895.308472 385.599976,832.977173 
	C377.215210,824.561340 369.436462,815.387573 364.838745,804.234009 
	C362.824402,799.347473 361.552094,793.926086 361.144104,788.654602 
	C360.325775,778.080872 360.100159,767.443420 360.088440,756.831787 
	C360.081573,750.579468 360.352570,744.207275 361.558594,738.098267 
	C363.993317,725.765625 371.539154,716.133850 379.584442,706.903198 
	C381.104797,705.158936 382.656281,703.428711 384.027679,701.569763 
	C391.045197,692.057678 390.505676,687.173828 382.717346,678.108826 
	C373.718323,667.634644 364.477905,657.120117 361.595886,643.007568 
	C360.516663,637.722839 360.061371,632.218811 360.087555,626.818481 
	C360.150360,613.875122 360.200836,600.899719 361.150085,588.003052 
	C361.896759,577.858093 367.447510,569.419983 373.822449,561.804932 
	C378.826111,555.827881 384.113434,549.995911 389.886841,544.776611 
	C399.316681,536.251648 402.617096,525.458801 402.968597,513.351685 
	C403.147461,507.191101 403.271667,501.006683 402.947174,494.858032 
	C402.099731,478.798981 407.498108,464.808960 416.827484,452.153809 
	C426.333984,439.258423 438.189697,428.999786 453.580200,424.063110 
	C460.472809,421.852264 468.081268,421.588806 475.409027,421.088348 
	C485.325653,420.411133 495.297485,420.566223 505.221619,419.967010 
	C513.026062,419.495819 518.972107,414.990509 524.579590,409.949799 
	C533.427551,401.996094 541.867310,393.442230 551.492126,386.557587 
	C556.670715,382.853363 563.830078,381.008636 570.320190,380.253357 
	C580.992554,379.011353 591.876038,378.700897 602.617004,379.185150 
	C612.722473,379.640717 623.002441,380.682953 632.762817,383.190643 
	C644.572998,386.224884 653.295532,394.988190 661.687012,403.331238 
	C711.911865,453.266296 761.919495,503.419769 812.250000,553.750000 
M597.176147,643.323730 
	C623.230774,669.378418 649.319580,695.399109 675.309143,721.518494 
	C680.103699,726.336975 684.826355,731.297424 689.004333,736.643921 
	C696.803284,746.624268 700.108398,758.006104 696.355286,770.411255 
	C690.197327,790.765198 673.051697,795.090454 655.690613,791.182373 
	C647.678345,789.378723 641.625183,784.064087 636.008911,778.456787 
	C579.869507,722.406677 523.829651,666.256653 467.631195,610.265930 
	C462.753357,605.406189 457.192505,601.118286 451.498444,597.223206 
	C445.751862,593.292175 438.224213,594.164673 433.072845,598.424988 
	C426.463654,603.890991 423.840179,611.241150 425.901062,617.964966 
	C428.735535,627.212830 435.414062,633.777100 441.895691,640.280396 
	C500.249786,698.829468 558.753662,757.229187 617.152649,815.733582 
	C619.797852,818.383606 621.975525,821.532776 624.172546,824.591919 
	C631.184570,834.355347 630.590027,845.610840 629.682129,856.648438 
	C628.812683,867.218384 622.612244,874.356506 612.278015,876.612488 
	C606.862671,877.794617 601.001831,876.920654 595.342590,877.004089 
	C588.857178,877.099731 582.932861,875.268494 577.872620,871.280518 
	C572.942505,867.395203 568.029785,863.414795 563.587402,858.995667 
	C531.567749,827.143127 499.684357,795.153625 467.710754,763.254700 
	C464.427856,759.979553 460.962860,756.857727 457.361877,753.936523 
	C448.907104,747.077637 439.792328,747.549500 434.254578,752.265503 
	C426.309387,759.031799 424.456329,768.012085 429.706116,777.088013 
	C432.317078,781.601929 435.563446,785.926392 439.243896,789.617126 
	C502.439117,852.988403 565.649963,916.345032 629.119934,979.440796 
	C640.617859,990.870972 653.010803,1001.451843 665.458679,1011.865234 
	C695.156799,1036.709473 729.038147,1054.143188 765.400818,1066.967041 
	C778.424316,1071.560059 792.135132,1072.238770 805.705444,1072.831421 
	C816.939209,1073.322144 828.267883,1072.727783 839.497314,1071.867676 
	C847.603394,1071.246948 856.121277,1070.709839 863.566467,1067.833984 
	C880.042114,1061.469971 896.298462,1054.314087 911.979431,1046.197021 
	C922.118103,1040.948975 932.057800,1034.473511 940.364441,1026.706177 
	C957.216675,1010.948486 973.296326,994.306519 988.953735,977.345215 
	C1004.687500,960.301331 1016.603333,940.600952 1025.423462,919.104126 
	C1034.291870,897.489502 1040.098877,875.267578 1039.038208,851.616455 
	C1038.488037,839.347168 1038.561401,827.048096 1037.910522,814.785950 
	C1037.545654,807.910522 1036.419312,801.061523 1035.386353,794.238464 
	C1033.349609,780.785645 1030.889038,767.392761 1029.079956,753.911133 
	C1027.657593,743.311279 1027.887939,732.420715 1025.723633,722.004333 
	C1021.672058,702.505371 1020.502136,682.793213 1020.165527,663.061951 
	C1019.782898,640.628845 1020.605286,618.172913 1021.058411,595.729980 
	C1021.137329,591.819946 1021.474976,587.778687 1022.557861,584.049072 
	C1027.284302,567.770447 1032.057129,551.494995 1037.348022,535.394104 
	C1041.365234,523.168945 1035.256958,512.828491 1027.531128,512.673096 
	C1023.363403,512.589294 1018.693909,513.850098 1015.040771,515.907227 
	C1000.009644,524.371155 988.770081,536.988159 979.182861,551.045288 
	C962.105774,576.084351 950.377991,603.693604 942.124084,632.689148 
	C936.672607,651.839722 932.622375,671.389954 927.981750,690.770081 
	C925.390930,701.590027 919.636841,709.986816 908.456543,712.646362 
	C890.940674,716.812988 875.422424,713.036560 862.293457,699.878906 
	C781.892151,619.302429 701.393311,538.823181 620.782532,458.456421 
	C616.064575,453.752716 610.382324,449.811951 604.619995,446.412720 
	C597.726379,442.346069 591.611084,443.451477 586.016968,448.471527 
	C579.663818,454.172821 577.041321,461.376587 580.342285,468.272125 
	C583.144104,474.125031 586.753235,479.973053 591.284790,484.558533 
	C648.202454,542.152954 705.358154,599.512146 762.439758,656.944580 
	C774.369385,668.947510 775.378540,683.694763 771.364563,698.773804 
	C768.850891,708.217224 760.613708,712.176941 751.154785,713.447327 
	C737.511475,715.279724 724.677917,713.662964 714.346924,703.741821 
	C696.813599,686.904053 679.486328,669.847473 662.275024,652.679688 
	C642.817566,633.271423 623.591614,613.631042 604.247314,594.109131 
	C597.818604,587.621399 591.356079,581.166748 584.872986,574.733337 
	C558.740417,548.801208 532.679993,522.794922 506.349854,497.064758 
	C502.808044,493.603668 498.126678,490.998993 493.538696,488.989227 
	C486.259460,485.800568 477.586792,488.698608 472.309814,495.218384 
	C467.697144,500.917389 467.288940,509.292908 472.446442,515.805176 
	C478.797333,523.824402 485.588867,531.564392 492.794617,538.824951 
	C527.309753,573.602417 562.029358,608.176941 597.176147,643.323730 
z"/>
<path fill="#FEFEFE" opacity="1.000000" stroke="none" 
	d="
M405.732300,1048.266113 
	C394.627625,1037.739868 383.338470,1027.879761 373.094055,1017.032715 
	C365.076965,1008.544067 357.643768,999.302734 351.203888,989.567261 
	C337.356049,968.633118 327.117523,945.758118 321.592865,921.338318 
	C318.986755,909.818787 318.133392,897.139160 326.582245,886.353516 
	C331.279785,880.356750 337.490173,876.923096 344.582367,876.184326 
	C363.055725,874.260010 375.371735,879.611511 381.881653,899.118774 
	C388.795898,919.837585 397.976288,939.541260 411.505432,956.529175 
	C430.233185,980.044556 451.476044,1001.255066 478.988068,1014.706177 
	C490.593292,1020.380127 502.713318,1025.024780 514.701050,1029.886597 
	C528.218384,1035.368530 534.754639,1045.776001 534.809570,1059.788940 
	C534.876770,1076.931274 523.943420,1089.783569 505.758911,1090.309204 
	C488.233337,1090.816040 472.897400,1084.420532 457.362000,1078.514038 
	C439.620148,1071.768677 423.104340,1062.451294 408.148468,1050.593628 
	C407.369690,1049.976196 406.712097,1049.206055 405.732300,1048.266113 
z"/>
<path fill="#FEFEFE" opacity="1.000000" stroke="none" 
	d="
M815.533081,488.431976 
	C809.270508,478.939911 803.483398,469.554352 797.088196,460.603210 
	C787.213196,446.781372 774.669250,435.430511 762.548645,423.618286 
	C750.633972,412.006836 735.667358,405.342285 722.338135,396.075958 
	C714.924866,390.922333 710.902466,383.929504 711.045654,374.860382 
	C711.147339,368.422852 711.062195,361.884064 712.173340,355.586823 
	C713.434326,348.440613 722.125732,342.170502 729.044556,340.904938 
	C752.338379,336.644165 772.044495,345.613281 789.728210,358.717102 
	C804.799133,369.884796 818.900208,382.628448 832.085693,396.000732 
	C846.288330,410.404633 859.060608,426.182495 867.613464,444.967560 
	C873.385620,457.645172 876.127136,470.625916 873.014954,484.215698 
	C869.325806,500.325165 853.772644,506.960724 838.958496,504.643158 
	C828.735535,503.043823 821.214661,497.339050 815.533081,488.431976 
z"/>
<path fill="#FEFEFE" opacity="1.000000" stroke="none" 
	d="
M810.341553,285.335907 
	C816.610840,279.941864 823.733643,279.416992 831.341125,278.785919 
	C852.668152,277.016754 868.778625,287.127533 883.639771,300.272980 
	C892.726257,308.310425 901.675476,316.608643 909.815430,325.579926 
	C917.543091,334.096741 924.615662,343.315857 931.099792,352.823914 
	C938.157776,363.173370 938.648193,383.907806 929.369751,393.675262 
	C925.724365,397.512817 921.729248,400.500275 916.423340,401.128204 
	C906.115784,402.348022 895.567688,404.099060 886.062378,398.368591 
	C881.459167,395.593414 877.093445,391.960938 873.608215,387.874084 
	C857.740173,369.267090 840.499023,352.232880 820.654663,337.804352 
	C813.522461,332.618591 806.511353,326.538849 804.940613,317.119476 
	C803.112427,306.156311 801.958618,295.049255 810.341553,285.335907 
z"/>
<path fill={color} opacity="1.000000" stroke="none" 
	d="
M596.926208,643.073669 
	C562.029358,608.176941 527.309753,573.602417 492.794617,538.824951 
	C485.588867,531.564392 478.797333,523.824402 472.446442,515.805176 
	C467.288940,509.292908 467.697144,500.917389 472.309814,495.218384 
	C477.586792,488.698608 486.259460,485.800568 493.538696,488.989227 
	C498.126678,490.998993 502.808044,493.603668 506.349854,497.064758 
	C532.679993,522.794922 558.740417,548.801208 584.872986,574.733337 
	C591.356079,581.166748 597.818604,587.621399 604.247314,594.109131 
	C623.591614,613.631042 642.817566,633.271423 662.275024,652.679688 
	C679.486328,669.847473 696.813599,686.904053 714.346924,703.741821 
	C724.677917,713.662964 737.511475,715.279724 751.154785,713.447327 
	C760.613708,712.176941 768.850891,708.217224 771.364563,698.773804 
	C775.378540,683.694763 774.369385,668.947510 762.439758,656.944580 
	C705.358154,599.512146 648.202454,542.152954 591.284790,484.558533 
	C586.753235,479.973053 583.144104,474.125031 580.342285,468.272125 
	C577.041321,461.376587 579.663818,454.172821 586.016968,448.471527 
	C591.611084,443.451477 597.726379,442.346069 604.619995,446.412720 
	C610.382324,449.811951 616.064575,453.752716 620.782532,458.456421 
	C701.393311,538.823181 781.892151,619.302429 862.293457,699.878906 
	C875.422424,713.036560 890.940674,716.812988 908.456543,712.646362 
	C919.636841,709.986816 925.390930,701.590027 927.981750,690.770081 
	C932.622375,671.389954 936.672607,651.839722 942.124084,632.689148 
	C950.377991,603.693604 962.105774,576.084351 979.182861,551.045288 
	C988.770081,536.988159 1000.009644,524.371155 1015.040771,515.907227 
	C1018.693909,513.850098 1023.363403,512.589294 1027.531128,512.673096 
	C1035.256958,512.828491 1041.365234,523.168945 1037.348022,535.394104 
	C1032.057129,551.494995 1027.284302,567.770447 1022.557861,584.049072 
	C1021.474976,587.778687 1021.137329,591.819946 1021.058411,595.729980 
	C1020.605286,618.172913 1019.782898,640.628845 1020.165527,663.061951 
	C1020.502136,682.793213 1021.672058,702.505371 1025.723633,722.004333 
	C1027.887939,732.420715 1027.657593,743.311279 1029.079956,753.911133 
	C1030.889038,767.392761 1033.349609,780.785645 1035.386353,794.238464 
	C1036.419312,801.061523 1037.545654,807.910522 1037.910522,814.785950 
	C1038.561401,827.048096 1038.488037,839.347168 1039.038208,851.616455 
	C1040.098877,875.267578 1034.291870,897.489502 1025.423462,919.104126 
	C1016.603333,940.600952 1004.687500,960.301331 988.953735,977.345215 
	C973.296326,994.306519 957.216675,1010.948486 940.364441,1026.706177 
	C932.057800,1034.473511 922.118103,1040.948975 911.979431,1046.197021 
	C896.298462,1054.314087 880.042114,1061.469971 863.566467,1067.833984 
	C856.121277,1070.709839 847.603394,1071.246948 839.497314,1071.867676 
	C828.267883,1072.727783 816.939209,1073.322144 805.705444,1072.831421 
	C792.135132,1072.238770 778.424316,1071.560059 765.400818,1066.967041 
	C729.038147,1054.143188 695.156799,1036.709473 665.458679,1011.865234 
	C653.010803,1001.451843 640.617859,990.870972 629.119934,979.440796 
	C565.649963,916.345032 502.439117,852.988403 439.243896,789.617126 
	C435.563446,785.926392 432.317078,781.601929 429.706116,777.088013 
	C424.456329,768.012085 426.309387,759.031799 434.254578,752.265503 
	C439.792328,747.549500 448.907104,747.077637 457.361877,753.936523 
	C460.962860,756.857727 464.427856,759.979553 467.710754,763.254700 
	C499.684357,795.153625 531.567749,827.143127 563.587402,858.995667 
	C568.029785,863.414795 572.942505,867.395203 577.872620,871.280518 
	C582.932861,875.268494 588.857178,877.099731 595.342590,877.004089 
	C601.001831,876.920654 606.862671,877.794617 612.278015,876.612488 
	C622.612244,874.356506 628.812683,867.218384 629.682129,856.648438 
	C630.590027,845.610840 631.184570,834.355347 624.172546,824.591919 
	C621.975525,821.532776 619.797852,818.383606 617.152649,815.733582 
	C558.753662,757.229187 500.249786,698.829468 441.895691,640.280396 
	C435.414062,633.777100 428.735535,627.212830 425.901062,617.964966 
	C423.840179,611.241150 426.463654,603.890991 433.072845,598.424988 
	C438.224213,594.164673 445.751862,593.292175 451.498444,597.223206 
	C457.192505,601.118286 462.753357,605.406189 467.631195,610.265930 
	C523.829651,666.256653 579.869507,722.406677 636.008911,778.456787 
	C641.625183,784.064087 647.678345,789.378723 655.690613,791.182373 
	C673.051697,795.090454 690.197327,790.765198 696.355286,770.411255 
	C700.108398,758.006104 696.803284,746.624268 689.004333,736.643921 
	C684.826355,731.297424 680.103699,726.336975 675.309143,721.518494 
	C649.319580,695.399109 623.230774,669.378418 596.926208,643.073669 
z"  
    />
    </svg>
  );
};
export default CustomImage;